import { TConstructionCard } from "@/app/types/constructionPageTypes"
import ConstructionCard from "./ConstructionCard"

const ConstructionChunks = (
	{
		data,
		grids = 2,
		indexing = 0,
		setActiveModal,
		setModalData,
	}: {
		data: TConstructionCard[]
		grids?: number
		indexing?: number
		setActiveModal: (value: boolean) => void
        setModalData: (data: TConstructionCard | null) => void
	},
) => {
	return (
		<div
			className={`lg:grid lg:grid-cols-${grids} lg:gap-x-[1.75rem] lg:gap-y-[4rem] flex flex-col`}
		>
			{data.map((card: any, index: number) => (
				<ConstructionCard
					data={{ ...card, index: index + indexing }}
					key={card.title}
					setActiveModal={setActiveModal}
                    setModalData={setModalData}
				/>
			))}
		</div>
	)
}

export default ConstructionChunks
